import {
  FormSelect
} from "@/components";
import { DESCRIPTION, CATEGORY_NAME, PROPERTY_CATEGORY } from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { schema } from "./validations";
import { routes } from "@/routes/utils";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";
import useAddEdit from "./useAddEdit";

const AddEdit = () => {
  const { propertyCategory, billingPropertyCategory } = useAddEdit();

  const addEditHook = useAddEditMasterModule({
    moduleName: "Billing Category",
    moduleRoute: `${routes.masterData}/${routes.billingCategory}`,
    schema,
    defaultValues: { [CATEGORY_NAME]: "", [DESCRIPTION]: "", [PROPERTY_CATEGORY]: [] },
    nameFieldKey: CATEGORY_NAME,
    arrayCustomFieldKeys: [
      {
        apiKey: "propertyCategories",
        formKey: PROPERTY_CATEGORY,
        idKey: "categoryId",
      },
    ],
    queryKeyToInvalidate: "billing-categories",
    module: "billing-categories",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  const {form, requiredFields, isView} = addEditHook;
  const {errors} = form.formState;

  const customFields = (
    <FormSelect
      multiSelect
      name={PROPERTY_CATEGORY}
      control={form.control}
      label="Property Category"
      placeholder="Please select"
      error={(errors as any)[PROPERTY_CATEGORY]?.message}
      isRequired={requiredFields.includes(PROPERTY_CATEGORY)}
      disabled={isView}
      options={(propertyCategory || [])?.map((data: any) => ({
        value: data?.categoryId?.toString(),
        label: data?.categoryName,
        disabled: billingPropertyCategory.some(
          (val: any) =>
            val.categoryId?.toString() ==
            data?.categoryId?.toString()
        ),
      }))}
    />
  )
  
  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Category Name"
      customFields={customFields}
    />
  );
};

export default AddEdit;
